import { useForm } from '@inertiajs/inertia-react';
import Icon from 'app/components/Icon'
import DateInput from 'app/fragments/Forms/DateInput';
import Form, { FormContext } from 'app/fragments/Forms/Form';
import TimeInput from 'app/fragments/Forms/DateTimeInput';
import moment from 'moment';
import React, { useContext, useEffect } from 'react'

interface Props {
}

function DoubleDatePicker(props: Props) {
    const { } = props

    let today = moment().endOf('day');
    let weekAgo = moment().subtract(7, 'days').startOf('day');

    return (
        <div className="flex justify-between items-center mob:flex-wrap">
            <div>
                <DateInput name="start" placeholder={weekAgo.format('DD. MM. YYYY')} />
            </div>
            <div className="w-16px h-1px bg-white mx-16px mb-12px mob:hidden"></div>
            <div>
                <DateInput name="end" placeholder={today.format('DD. MM. YYYY')} />
            </div>
        </div>
    )
}

export default DoubleDatePicker
